import React from 'react';
import { Helmet } from 'react-helmet-async';

const benefits = [
  {
    title: 'Competitive salary',
    copy: 'Market-aligned pay with performance bonuses for top contributors.',
  },
  {
    title: 'Health benefits',
    copy: 'Comprehensive medical coverage for you and your family.',
  },
  {
    title: 'Professional growth',
    copy: 'Learning stipends, internal workshops, and mentorship from industry leaders.',
  },
  {
    title: 'Work-life balance',
    copy: 'Flexible hours, hybrid options, and wellness breaks to recharge.',
  },
  {
    title: 'Collaborative culture',
    copy: 'A supportive team that values innovation and celebrates wins together.',
  },
];

const Careers = () => {
  return (
    <>
      <Helmet>
        <title>Careers - Dental Stores</title>
        <meta name="description" content="Join our team at Dental Stores. Explore career opportunities in the dental industry." />
      </Helmet>
      <div style={{ padding: '48px 24px 96px', maxWidth: '960px', margin: '0 auto', color: '#1f2933' }}>
        <header style={{ marginBottom: '48px' }}>
          <p
            style={{
              margin: 0,
              color: '#1565C0',
              fontWeight: '600',
              letterSpacing: '0.26em',
              textTransform: 'uppercase',
              fontSize: '12px',
            }}
          >
            Build your next chapter
          </p>
          <h1 style={{ fontSize: '38px', fontWeight: '700', margin: '12px 0 0', lineHeight: 1.25, color: '#102a43' }}>
            Careers at Dental Stores
          </h1>
          <p style={{ marginTop: '18px', fontSize: '17px', lineHeight: 1.7, maxWidth: '720px', color: '#52606d' }}>
            We're scaling dental care across India and looking for people who bring energy, skill, and empathy to the
            table.
          </p>
        </header>

        <section style={{ display: 'grid', gap: '40px' }}>
          <article
            style={{
              border: '2px dashed #d9e2ec',
              borderRadius: '16px',
              padding: '40px',
              textAlign: 'center',
              backgroundColor: '#f8fafc',
              display: 'grid',
              gap: '20px',
            }}
          >
            <p style={{ margin: 0, fontSize: '18px', color: '#627d98' }}>
              We're always on the lookout for talented individuals ready to raise the bar in dental retail.
            </p>
            <button
              type="button"
              style={{
                padding: '15px 32px',
                backgroundColor: '#1565C0',
                color: '#ffffff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              See Open Positions
            </button>
          </article>

          <article style={{ display: 'grid', gap: '18px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Why work with us?</h2>
            <div style={{ display: 'grid', gap: '18px', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
              {benefits.map((benefit) => (
                <div
                  key={benefit.title}
                  style={{ border: '1px solid #d9e2ec', borderRadius: '16px', padding: '22px', backgroundColor: '#ffffff' }}
                >
                  <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#102a43' }}>{benefit.title}</h3>
                  <p style={{ margin: '10px 0 0', fontSize: '15px', color: '#52606d', lineHeight: 1.6 }}>{benefit.copy}</p>
                </div>
              ))}
            </div>
          </article>

          <article style={{ display: 'grid', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>How to apply</h2>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              Email your resume and a short note about the role you're interested in to{' '}
              <strong>careers@dentalstores.in</strong>. Include the position title in the subject line—we review every
              application and respond within 5–7 business days.
            </p>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              Don't see a perfect fit? Send us your profile anyway. We love hearing from passionate professionals and
              often create roles for the right talent.
            </p>
          </article>
        </section>
      </div>
    </>
  );
};

export default Careers;
